module.exports = __webpack_public_path__ + "static/media/new-hampshire.51abba6f.png";